<template>
  <div class="login-container">

    <el-form ref="form" :model="form" class="login-form" auto-complete="on" label-position="left">

      <div class="title-container">
        <h3 class="title">登陆</h3>
      </div>

      <el-form-item prop="username">
        <span class="svg-container svg-container_login">
          <svg-icon icon-class="user" />
        </span>
        <el-input
          v-model="form.username"
          placeholder="用户名"
          name="username"
          type="text"
          auto-complete="on"
        />
      </el-form-item>

      <el-form-item prop="password">
        <span class="svg-container">
          <svg-icon icon-class="password" />
        </span>
        <el-input
          type="password"loginPost
          v-model="form.password"
          name="password"
          auto-complete="on"
          @keyup.enter.native="handleLogin" />
        <span class="show-pwd" @click="showPwd">
          <svg-icon icon-class="eye" />
        </span>
      </el-form-item>

      <el-button :loading="loading" type="primary"
                 style="width:100%;margin-bottom:30px;"
                 @click.native.prevent="handleLogin">登陆
      </el-button>
    </el-form>

  </div>
</template>

<script>
import md5 from 'js-md5';

export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      loading:false,
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }

  },
  created() {
    // window.addEventListener('hashchange', this.afterQRScan)
  },
  destroyed() {
    // window.removeEventListener('hashchange', this.afterQRScan)
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
    },
    handleLogin() {
      this.form.password = md5(md5(this.form.password).substr(7,7)+md5(this.form.password))
      this.$common.post('user/loginPost',
        this.form,
        (response)=>{
          if(response.data.content==='notLogin'){
            this.$router.push({path : '/Login'})
          }
          if(response.data.content.sessionId){
            this.$cookie.set('sessionId', response.data.content.sessionId);
            this.$router.push({path : '/Manage'})
          }
          this.menuList = response.data.content;
        }
      )
    },
  }
}
</script>
<style>
  .login-container{
    width: 600px;
    margin: 200px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue